import React, { useEffect, useState, useRef } from 'react';
import { mfaOtpStyles } from './mfaOtpStyles';
import { TextField, Grid, CircularProgress } from '@material-ui/core';
import { useApolloClient } from '@apollo/client';
import MyEirLoginHeader from './MyEirLoginHeader';
import MyEirLoginFooter from './MyEirLoginFooter';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';
import MyEirRegistrationErrorsPopup from '../../sharedcomponents/MyEirPostpayRegistration/MyEirRegistrationErrorsPopup';
import { setSessionStorageValues, validateMfaOtpApi } from './loginOperation.util';
import {
    addDataToEirAppDB,
    getDataFromEirAppDB,
    updateDataToEirAppDB,
} from '../redesign-5.2/biometrics/biometrics.util';
import { getAccountType, getFeature, sendMfaOtp, validateMfaOtp } from './loginOperation.api';
import {
    getTokenFromCookies,
    removeTokenFromCookies,
    setCookie,
    triggerAdobeApi,
} from '../redesign-5.2/redesign.api';
import { getNameAndAccountID } from '../getNameAndAccountNumber';
import { getServiceId } from '../getServiceID';
import SuccessPopup from './SuccessPopup';
import OptInOptOutPopup from './OptInOptOutPopup';
import EirButton from '../../theme/EirButton';

const MFAOtpScreen = props => {
    const [code, setCode] = useState('');
    const [activeCode, setActiveCode] = useState(false);
    const [valid, setValid] = useState(false);
    const [invalid, setInvalid] = useState(false);
    const [enableInput, setEnableInput] = useState(true);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [err, setErr] = useState(false);
    const [warning, setWarning] = useState(false);
    const graphql = useApolloClient();
    const useStyle = mfaOtpStyles({ activeCode });
    const [captchaFailed, setCaptchaFailed] = useState('');
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [isRecaptchaNull, setIsRecaptchaNull] = useState(false);
    const recaptchaRef = useRef(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [enableResetLink, setEnableResetLink] = useState(false);
    const [label, setLabel] = useState('Enter your verification code');
    const [deviceIdValue, setDeviceIdValue] = useState('');
    const [timer, setTimer] = useState(60);
    const [isCounting, setIsCounting] = useState(true);
    const [optPopup, setOptPopup] = useState(false);
    const [deviceOS, setdeviceOS] = useState('');
    const [isPrepay, setIsPrepay] = useState(false);
    const [otpUUID, setOtpUUID] = useState(props.otpUuid);
    const [isLoading, setIsLoading] = useState(false);
    const [userCredential, setUserCredential] = useState(null);

    const [errorText, setErrorText] = useState({
        headText: '',
        subText: '',
    });

    const token = getTokenFromCookies();
    const handleBackButton = () => {
        props.handleBackButton(2);
    };

    const resendOTP = async () => {
        setValid(false);
        setIsLoading(false);
        setTimer(60);
        setIsCounting(true);
        const data = await sendMfaOtp({ graphql, username: props.username, operation: 'LOGIN' });

        setOtpUUID(data.sendMFAOTP.uuid);
        setCode('');
        setValid(true);
        setErr(false);
    };
    const verifyOTP = async () => {
        try {
            setIsLoading(true);
            setEnableSubmit(false);
            setEnableInput(false);
            setEnableResetLink(false);
            setTimer(60);
            setIsCounting(true);

            let data = await validateMfaOtp({
                graphql,
                otp: code,
                otpUuid: props.flag === 'reset' ? props.otpUuid : otpUUID,
                operation: props.flag === 'reset' ? 'CHANGE_PASSWORD' : 'LOGIN',
            });
            const iOSstandaloneMode = window.navigator.standalone;
            const androidPwaMode = window.matchMedia('(display-mode:standalone)').matches;

            // Reset password journey
            if (props.flag === 'reset') {
                removeTokenFromCookies();
                if (data?.data?.validateMFAOTP?.mfaToken == undefined) {
                    setIsLoading(false);
                    setShowError(!showError);
                    setErrorText({
                        headText: 'Oops something went wrong',
                        subText: 'Email not found',
                    });
                } else {
                    setCookie('MFA', 'TOKEN', data?.data?.validateMFAOTP?.mfaToken);

                    // setShowSuccess(true);

                    setIsLoading(false);
                    props.handleNextFlow1();
                }
            }
            // Login flow
            else {
                if (data?.data?.validateMFAOTP?.mfaToken == undefined) {
                    setIsLoading(false);
                    setShowError(!showError);
                    setErrorText({
                        headText: 'Oops something went wrong',
                        subText: 'Email not found',
                    });
                } else {
                    setCookie('MFA', 'TOKEN', data?.data?.validateMFAOTP?.mfaToken);

                    if (
                        userCredential &&
                        userCredential?.user != undefined &&
                        userCredential?.user != props.username &&
                        userCredential?.deviceId != ''
                    ) {
                        console.log('Different account logged in.....');
                        if (data?.data?.validateMFAOTP?.deviceId != undefined) {
                            sessionStorage.setItem(
                                'TEMP_DEVICEID',
                                data?.data?.validateMFAOTP?.deviceId
                            );
                        }
                    } else {
                        if (data?.data?.validateMFAOTP?.deviceId != undefined) {
                            updateDataToEirAppDB({
                                deviceId: data?.data?.validateMFAOTP?.deviceId,
                                user: props.username,
                            });
                            if (data?.data?.validateMFAOTP?.deviceId.includes('iOS')) {
                                setdeviceOS('iOS');
                            }
                        }
                    }

                    setDeviceIdValue(data?.data?.validateMFAOTP?.deviceId);
                    const featureList = await getFeature({
                        graphql,
                        token,
                        username: props.username,
                    });

                    const type = await getAccountType({ graphql, token });
                    await setSessionStorageValues({
                        loginOperation: props.loginOperation,
                        token,
                        enteredName: props.username,
                        featureList,
                    });
                    if (type.accountType.prepay && type.accountType.postpay) {
                        setIsLoading(false);
                        props.setLoginScreen(1);
                        props.setWaitingApiRes(false);
                    } else if (type.accountType.prepay && !type.accountType.postpay) {
                        // Prepay journey
                        sessionStorage.setItem('LoggedinUserBillType', 'Prepay');
                        setIsPrepay(true);
                        props.setWaitingApiRes(false);
                        // Biometrics capability check
                        if (
                            userCredential &&
                            userCredential?.user != undefined &&
                            userCredential?.user != props.username &&
                            userCredential?.deviceId != '' &&
                            userCredential?.credentialId != ''
                        ) {
                            console.log('Different account logged in.....');
                            setIsLoading(false);
                            setShowSuccess(true);
                        } else {
                            if (
                                (iOSstandaloneMode || androidPwaMode) &&
                                window.PublicKeyCredential
                            ) {
                                console.log('biometrics allowed');
                                if (props?.loginOperation?.data?.login?.biometricOptedIn == null) {
                                    console.log(
                                        'show biometrics preference popup UI and load dashboard'
                                    );
                                    setIsLoading(false);
                                    setOptPopup(!optPopup);
                                }
                            } else {
                                setIsLoading(false);
                                setShowSuccess(true);
                            }
                        }
                    } else if (type.accountType.postpay && !type.accountType.prepay) {
                        sessionStorage.setItem('LoggedinUserBillType', 'Bill');

                        console.log('call analytcs......');
                        const response2 = await getNameAndAccountID(graphql);
                        const serviceResponse = await getServiceId(graphql);
                        props.setWaitingApiRes(false);
                        await triggerAdobeApi({ graphql, name: 'login' });
                        setIsPrepay(false);
                        // Biometrics capability check
                        if (
                            userCredential &&
                            userCredential?.user != undefined &&
                            userCredential?.user != props.username &&
                            userCredential?.deviceId != '' &&
                            userCredential?.credentialId != ''
                        ) {
                            console.log('Different account logged in.....');
                            setIsLoading(false);
                            setShowSuccess(true);
                        } else {
                            if (
                                (iOSstandaloneMode || androidPwaMode) &&
                                window.PublicKeyCredential
                            ) {
                                console.log('biometrics allowed');
                                if (props?.loginOperation?.data?.login?.biometricOptedIn == null) {
                                    console.log(
                                        'show biometrics preference popup UI and load dashboard'
                                    );
                                    setIsLoading(false);
                                    setOptPopup(!optPopup);
                                }
                            } else {
                                setIsLoading(false);

                                setShowSuccess(true);
                            }
                        }
                    }
                }
            }
            setIsLoading(false);
        } catch (error) {
            setValid(false);
            setIsLoading(false);
            setIsCounting(false);
            // console.log(err);
            if (error.graphQLErrors !== undefined) {
                if (error.graphQLErrors[0].message.indexOf('Otp not') > -1) {
                    setErr('Enter a valid 6-digit verification code.');
                } else {
                    setErr('Something went wrong');
                }
            } else {
                if (error.message.indexOf('Incorrect otpcode') > -1) {
                    setErr('Enter a valid 6-digit verification code.');
                } else {
                    setErr(error.message);
                }
            }
            console.error(error);
        } finally {
            setEnableSubmit(true);
            setEnableInput(true);
        }
    };
    const handleChange = event => {
        setCode(event.target.value);
        if (event.target.value) {
            if (/\D/.test(event.target.value)) {
                setInvalid(true);
                setValid(false);
            } else {
                if (event.target.value.length !== 6) {
                    setValid(false);
                    setInvalid(false);
                    setWarning(false);
                } else {
                    setEnableSubmit(true);
                    setInvalid(false);
                    setErr(false);
                    setWarning(false);
                    setValid(true);
                }
            }
        } else {
            setErr(false);
            setInvalid(false);
            setValid(false);
            setWarning(false);
        }
    };
    const handleFocus = () => {
        setLabel('Verification code');
    };
    const handleBlur = () => {
        setLabel('Enter your verification code');
    };

    useEffect(() => {
        let interval;
        if (isCounting && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsCounting(false);
        }
        return () => clearInterval(interval);
    }, [isCounting, timer]);

    // onload indexedDB values
    useEffect(() => {
        const fetchDataFromEirAppDB = async () => {
            const value = await getDataFromEirAppDB('user_credential');
            setUserCredential(value);
        };
        fetchDataFromEirAppDB();
    }, []);

    return (
        <div className={useStyle.otpContainer}>
            <div className={useStyle.otpcardContainer}>
                <MyEirLoginHeader
                    headerText='Secure your account'
                    loginScreen={props.loginScreen + 1}
                    handleBackButton={handleBackButton}
                />

                {/* body part */}
                <div className={`${useStyle.body} verification-body`}>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className={useStyle.text}>
                                <Typography className={useStyle.text}>
                                    For security reasons, we've sent a verification code via SMS to
                                    the account holder's mobile number{' '}
                                    <Typography
                                        className={useStyle.middleText}
                                        aria-label={
                                            props.flag === 'reset'
                                                ? `Verification code sent to your phone number ending in ${props.delivery}`
                                                : `Verification code sent to your phone number ending in ${props.loginOperation.data.login.otpDelivery}`
                                        }
                                    >
                                        {' '}
                                        ******
                                        {props.flag === 'reset'
                                            ? props.delivery
                                            : props.loginOperation.data.login.otpDelivery}{' '}
                                    </Typography>
                                    linked to the account
                                </Typography>
                            </div>
                            <TextField
                                aria-label='Enter your verification code'
                                className={`${useStyle.codes} verification-code`}
                                id='verification-code'
                                type='text'
                                label='Enter your verification code'
                                variant='outlined'
                                color='primary'
                                // onFocus={handleFocus}
                                // onBlur={handleBlur}
                                onChange={handleChange}
                                value={code}
                                disabled={!enableInput}
                                onClick={() => setActiveCode(!activeCode)}
                                inputProps={{
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*',
                                    maxLength: 6,
                                }}
                                error={invalid || Boolean(err) || warning}
                                InputLabelProps={{
                                    classes: {
                                        root: 'text-field-input-label-props-root',
                                        shrink:
                                            'text-field-input-label-props-shrink' +
                                            (invalid || err
                                                ? ' text-field-input-label-props-shrink-invalid'
                                                : ''),
                                        focused:
                                            'text-field-input-label-props-focused' +
                                            (invalid || err
                                                ? ' text-field-input-label-props-focused-invalid'
                                                : ''),
                                    },
                                }}
                                InputProps={{
                                    classes: {
                                        root:
                                            'text-field-input-props-root' +
                                            (!!code ? ' text-field-input-props-root-filled' : ''),
                                        focused: 'text-field-input-props-focused',
                                        notchedOutline:
                                            'text-field-input-props-notchedOutline' +
                                            (invalid ||
                                            (!!props.forgotUserName ? props.unameErr : err)
                                                ? ' text-field-input-props-notchedOutline-invalid'
                                                : ''),
                                        input: 'text-field-input-props-input',
                                    },
                                }}
                            />

                            {invalid ? (
                                <div className='invalid-messages'>Not a numeric value.</div>
                            ) : err ? (
                                <div className='invalid-messages'>{err}</div>
                            ) : warning ? (
                                <div className='invalid-messages'>
                                    Oops! The code you entered is incorrect or may have expired.
                                    Please try again.
                                </div>
                            ) : (
                                ''
                            )}

                            <Typography className={useStyle.resend} onClick={resendOTP}>
                                Didn’t receive a code?
                                <Typography
                                    tabindex='0'
                                    role='link'
                                    aria-label='Resend verification code'
                                    className={useStyle.link}
                                    style={isCounting ? { cursor: 'text' } : { cursor: 'pointer' }}
                                    component='span'
                                    disabled={isCounting}
                                >
                                    {isCounting ? `Try again ${timer}s` : `Resend SMS`}
                                </Typography>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
                {!isLoading ? (
                    <MyEirLoginFooter
                        ariaLabel1='Continue to next step'
                        button1Text='Continue'
                        handleButton1Click={verifyOTP}
                        button1Enabled={valid && code != '' ? enableSubmit : false}
                    />
                ) : (
                    <EirButton
                        variants='primaryButtonMedium'
                        style={{ padding: '0.5rem 2.5rem' }}
                        // className={classes.paymentContent}
                    >
                        <CircularProgress
                            disableShrink
                            style={{
                                color: 'white',
                                width: '17px',
                                height: '17px',
                                marginRight: '5px',
                            }}
                        />
                        Continuing...
                    </EirButton>
                )}
                {showSuccess ? (
                    <SuccessPopup
                        open={showSuccess}
                        setOpen={setShowSuccess}
                        text="Your device has been successfully verified. You're now securely signed in."
                        prepay={isPrepay}
                        // flag={props.flag === 'reset' ? 'reset' : ''}
                    />
                ) : (
                    ''
                )}
                {optPopup && (
                    <OptInOptOutPopup
                        open={optPopup}
                        setOpen={setOptPopup}
                        deviceId={deviceIdValue}
                        username={props.username}
                        prepay={isPrepay}
                        flag={deviceOS === 'iOS' ? 'iOS' : 'Android'}
                        subText1={
                            deviceOS === 'iOS'
                                ? 'Use Face ID to login for faster and easier access to your account.'
                                : 'Use face or finger print to login for faster and easier access to your account.'
                        }
                        subText2='If you have multiple accounts, you can set up biometrics for your preferred account.'
                        subText3='Would you like to set it up now?'
                        ctaText={
                            deviceOS === 'iOS' ? 'Turn on Face ID' : 'Enable face or fingerprint'
                        }
                    />
                )}
                {showError ? (
                    <MyEirRegistrationErrorsPopup
                        open={showError}
                        setOpen={setShowError}
                        headText={errorText.headText}
                        subText={errorText.subText}
                    />
                ) : (
                    ''
                )}
            </div>
        </div>
    );
};

export default MFAOtpScreen;
